import React from "react";
import styled from "styled-components";
import * as sanitizeHtml from "sanitize-html";
import {
  H5,
  BodyStyle,
  BodySemiboldStyle
} from "storybook-components/Typography";
import BlogArticleLink from "../BlogArticleLink";
import NotchedImg from "./NotchedImg";
import AuthorInfo from "./AuthorInfo";
import DateAndReadTime from "./PublishDate";
import PostRowCard from "./PostRowCard";
import IsRichTextValidator from "../Helpers/IsRichTextValidator";
import sanitizeSettings from "../../../config/sanitize-html";

const checkLongDescription = (node, longDescription) => {
  if (longDescription) {
    return (
      <>
        <DescriptionText
          className="text"
          dangerouslySetInnerHTML={{
            __html: sanitizeHtml(
              node.longDescription.childMarkdownRemark.html,
              sanitizeSettings
            )
          }}
        />
      </>
    );
  }
  return null;
};

const checkHeroImage = (node, heroImage) => {
  if (heroImage) {
    return <NotchedImg imageData={node.heroImage} alt={node.heroImage.title} />;
  }
  return <NotchedImg alt="no-hero-image" />;
};

const PreviewWrapper = styled(BlogArticleLink)`
  display: block;
  width: 100%;
  margin: auto;
  padding: 0;
  border-bottom: 1px solid #000;
  text-decoration: none;
  color: unset;
  &:last-of-type {
    border-bottom: none;
  }
`;

const PostTitle = styled(H5)`
  color: ${({ theme }) => theme.colors.green5};
  max-width: 560px;
  margin: 24px 0;
  ${props => props.theme.media.desktopUp`
    display: -webkit-box;
    margin: 16px 0 24px;
    height: 6.5rem;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
    overflow: hidden;
  `};
`;

const PaddedCopyWrapper = styled.div`
  padding: 16px;
`;

const DescriptionText = styled.div`
  ${BodyStyle};
  color: ${({ theme }) => theme.colors.gray12};
  p {
    height: 120px;
    display: -webkit-box;
    -webkit-line-clamp: 5;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
  a {
    ${BodySemiboldStyle}
    color: ${({ theme }) => theme.colors.green4};
    margin-left: 0;
  }
`;

export default ({ node }) => {
  const isRichText = IsRichTextValidator(node.richTextBody);
  const legacyBodyReadTime =
    node.body &&
    node.body.childMarkdownRemark &&
    node.body.childMarkdownRemark.timeToRead;
  return (
    <PostRowCard>
      <PreviewWrapper to={node.slug}>
        {checkHeroImage(node, node.heroImage)}
        <PaddedCopyWrapper>
          <PostTitle className="text">{node.title}</PostTitle>
          <DateAndReadTime
            publishDate={node.publishDate}
            readTime={!isRichText && legacyBodyReadTime}
            richTextData={node.richTextBody}
            marginTop="0"
          />

          {checkLongDescription(node, node.longDescription)}

          <AuthorInfo
            authorName={node.author ? node.author.name : ""}
            authorTitle={node.author ? node.author.title : ""}
            authorImg={
              node.author && node.author.image ? node.author.image.file.url : ""
            }
          />
        </PaddedCopyWrapper>
      </PreviewWrapper>
    </PostRowCard>
  );
};
